import { services } from '@/mocks/homeContent';

export default function ServicesSection() {
  return (
    <section id="services" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <p className="font-mincho text-primary-600 tracking-widest text-sm md:text-base mb-3">
            OUR SERVICES
          </p>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 leading-snug">
            京都のあらゆる<span className="text-primary-500 whitespace-nowrap">「片づけ」</span>
            <br className="md:hidden" />
            を、一社完結で。
          </h2>
          <p className="mt-5 text-foreground-600 text-sm md:text-base leading-relaxed">
            ご家庭の1点回収から、法人・不動産会社様の大型案件まで。
            京都府全域を担当エリアとし、丁寧かつスピーディーに対応します。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <article
              key={service.title}
              className="rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors flex flex-col"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  alt={`${service.title} 京都府対応`}
                  title={`${service.title}|${service.tag}`}
                  className="w-full h-full object-cover object-top"
                  src={service.image}
                />
                <span
                  className={`absolute top-3 left-3 px-3 py-1 rounded-full text-xs font-medium ${service.tagColor}`}
                >
                  {service.tag}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-xl font-bold text-foreground-950 mb-2">
                  {service.title}
                </h3>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  {service.desc}
                </p>
                <ul className="mt-auto grid grid-cols-2 gap-x-3 gap-y-2 pt-4 border-t border-background-200">
                  {service.features.map((f) => (
                    <li
                      key={f}
                      className="flex items-center gap-1.5 text-foreground-700 text-xs"
                    >
                      <span className="w-4 h-4 flex items-center justify-center text-accent-700">
                        <i className="ri-checkbox-circle-fill" />
                      </span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}